import Dropdown from "../utils/classes/Dropdown";
import { getQueryParams, updateQueryParam } from "../utils/queryParams";
import {
    getPagesElements,
    setPagesEventListeners,
    pageQueryKey,
    scrollElementIntoView,
} from "../utils/overview";

export default function(el) {
    const pagesEls = getPagesElements(el);
    const dropdowns = el.querySelectorAll(".dropdown");
    const queryParams = getQueryParams();

    const handleDropdownValueChange = (index, filterName, clickedElement, dropdown, e) => {
        e.preventDefault();

        let value = clickedElement.dataset.value;

        if (!value) return;

        if (value === filterName) value = null;

        updateQueryParam(queryParams, pageQueryKey, 1); // Reset page param
        updateQueryParam(queryParams, index, value, true, true);
    };

    for (const [index, d] of Object.entries(dropdowns)) {
        const dropdown = new Dropdown(d);
        const filterName = d.dataset.filterName;

        dropdown.run();
        dropdown.on("valueChange", handleDropdownValueChange.bind(null, index, filterName));
    }

    setPagesEventListeners(pagesEls, queryParams);

    scrollElementIntoView(queryParams);
}
